import { useTranslation } from 'react-i18next';

import { CodeMultiSelect } from './CodeMultiSelect';
import { LabelWithHelp } from './HelpTip';
import type { ScopeOption } from '../hooks/useScopeFilterOptions';

import { ProductScopeFilter } from './ProductScopeFilter';

export interface EntityScopeFilters {
  family_codes: string[];
  subfamily_codes: string[];
  warehouse_codes: string[];
  supplier_codes: string[];
  product_codes: string[];
}

export const EMPTY_ENTITY_SCOPE_FILTERS: EntityScopeFilters = {
  family_codes: [],
  subfamily_codes: [],
  warehouse_codes: [],
  supplier_codes: [],
  product_codes: [],
};

export function entityScopeFiltersKey(filters: EntityScopeFilters): string {
  return [
    filters.family_codes.join(','),
    filters.subfamily_codes.join(','),
    filters.warehouse_codes.join(','),
    filters.supplier_codes.join(','),
    filters.product_codes.join(','),
  ].join('|');
}

interface Props {
  value: EntityScopeFilters;
  onChange: (value: EntityScopeFilters) => void;
  families: ScopeOption[];
  warehouses: ScopeOption[];
  suppliers: ScopeOption[];
  disabled?: boolean;
}

export function ConsensusScopeFilters({
  value,
  onChange,
  families,
  warehouses,
  suppliers,
  disabled = false,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-end gap-3">
      <CodeMultiSelect
        id="consensus-filter-family"
        label={
          <LabelWithHelp
            label={t('scopeFilters.family')}
            help={t('demandPlanning.help.scopeFamily')}
          />
        }
        options={families}
        value={value.family_codes}
        onChange={(family_codes) => onChange({ ...value, family_codes })}
        disabled={disabled}
      />
      <CodeMultiSelect
        id="consensus-filter-warehouse"
        label={
          <LabelWithHelp
            label={t('scopeFilters.warehouse')}
            help={t('demandPlanning.help.scopeWarehouse')}
          />
        }
        options={warehouses}
        value={value.warehouse_codes}
        onChange={(warehouse_codes) => onChange({ ...value, warehouse_codes })}
        disabled={disabled}
      />
      <CodeMultiSelect
        id="consensus-filter-supplier"
        label={
          <LabelWithHelp
            label={t('scopeFilters.supplier')}
            help={t('demandPlanning.help.scopeSupplier')}
          />
        }
        options={suppliers}
        value={value.supplier_codes}
        onChange={(supplier_codes) => onChange({ ...value, supplier_codes })}
        disabled={disabled}
      />
      <ProductScopeFilter
        value={value.product_codes}
        onChange={(product_codes) => onChange({ ...value, product_codes })}
        disabled={disabled}
      />
    </div>
  );
}
